<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :title="encodingRules.pkId ? '编辑' : '新建'"
    width="600px"
    @close="$reset('form')"
  >
    <el-form ref="form" :model="encodingRules" :rules="ruleValidate" class="form" label-width="80px">
      <el-form-item label="规则名称" prop="tableName">
        <el-input v-model="encodingRules.tableName" placeholder="请输入编码规则名称" />
      </el-form-item>
      <el-form-item label="编码前缀">
        <el-input v-model="encodingRules.prefix" placeholder="请输入编码前缀" />
      </el-form-item>
      <el-form-item label="编码位数" prop="idlength">
        <el-input v-model="encodingRules.idlength" placeholder="请输入编码位数" />
      </el-form-item>
      <el-form-item label="规则描述">
        <el-input v-model="encodingRules.describe" type="textarea" autosize placeholder="请输入规则描述" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      encodingRules: {
        tableName: "",
        prefix: "",
        describe: "",
        idlength: "",
        pkId: 0,
      },
      ruleValidate: {
        tableName: { required: true, message: "请输入规则名称", trigger: "blur" },
        idlength: { required: true, message: "请输入编码位数", trigger: "blur" },
      },
    };
  },
  methods: {
    open(row) {
      this.dialogVisible = true;
      if (row) {
        this.encodingRules = Object.assign(this.encodingRules, row);
      }
    },

    // 提交
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          this.$http
            .save("basic", "codeRules", this.encodingRules)
            .then((resp) => {
              if (resp.success) {
                if (!this.encodingRules.pkId) {
                  this.$emit("save-success");
                  this.$message.success("添加成功");
                } else {
                  this.$emit("save-success");
                  this.$message.success("编辑成功");
                }
              }
              this.submitLoading = false;
              this.dialogVisible = false;
            })
            .catch(() => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>
